import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { ParagraphComponent } from '../../paragraph/paragraph.component';
import { DiscountTypeDetailsComponent } from './discount-type-details/discount-type-details.component';
import { DiscountTypeComponent } from './discount-type/discount-type.component';

@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    I18nModule,
    NgbDropdownModule,
    MatIconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoParagraphComponent: {
          component: ParagraphComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        DiscountTypeComponent: {
          component: DiscountTypeComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        DiscountTypeDetailsComponent: {
          component: DiscountTypeDetailsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    DiscountTypeComponent,
    DiscountTypeDetailsComponent,
  ],
})
export class DiscountsModule {}
